import type { INote, INoteAttachment } from "../Types"

export interface NestedNoteRows {
  Note: INote[];
  NoteAttachment: INoteAttachment[];
}

export function nestedNoteRows(notes: readonly INote[]): NestedNoteRows {
  const noteById = new Map<number, INote>();
  const attachmentById = new Map<number, INoteAttachment>();
  for (const note of notes) {
    noteById.set(note.id, note);
    for (const attachment of note.attachments ?? []) {
      attachmentById.set(attachment.id, attachment);
    }
  }
  return {
    Note: Array.from(noteById.values()),
    NoteAttachment: Array.from(attachmentById.values()),
  };
}
